import { NavDropdown } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { getPath } from '../../MultilingualRouter/MultilingualRouter'

const MenuDropdown = ({ menuItem, path }) => (
  <NavDropdown
    align="end"
    title={(
      <strong className="nav-link-title">
        {menuItem.icon && <i className="material-icons mb-0 me-1 align-middle text-primary">{menuItem.icon}</i>}
        <span>{menuItem.title}</span>
      </strong>
    )}
  >
    {menuItem?.SubMenuItem?.map((subItem) => {
      const linkPath = subItem?.linkId?.urlId ? getPath(subItem.linkId.urlId) : ''

      return (
        <div key={`${subItem.link}${subItem.id}`}>
          {subItem.hasDivider && <NavDropdown.Divider className="d-none d-xl-block my-1" />}
          <NavDropdown.Item
            to={subItem.link?.length > 0 ? subItem.link : linkPath}
            className={`px-xl-3 ${path === linkPath ? ' active' : ''}`}
            target={subItem.link?.length > 0 ? '_blank' : undefined}
            rel={subItem.link?.length > 0 ? 'noreferrer' : undefined}
            as={Link}
          >
            <i className={`material-icons mb-0 me-2 align-middle ${path === linkPath ? 'text-white' : 'text-primary'}`}>
              {subItem.icon}
            </i>
            <span className="align-middle">{subItem.title}</span>
          </NavDropdown.Item>
        </div>
      )
    })}
  </NavDropdown>
)

MenuDropdown.propTypes = {
  menuItem: PropTypes.instanceOf(Object).isRequired,
  path: PropTypes.string.isRequired
}

export default MenuDropdown
